import axios from "axios";

export const envioNuevoPedido = async (entidad) => {


    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/a3bde707-edcf-4db1-b04c-525f64729f12', //test
         url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/a3bde707-edcf-4db1-b04c-525f64729f12',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}